export default class RequestsWatcher {
    /**
     * Create a proxy handler for handling the request history.
     * @param {RequestsHistory} history
     */
    constructor(history) {
        this.history = history;
    }

    /**
     * Function call trap for the proxy handler.
     * @param {Function} operation
     * @param {{}} resource
     * @param {[]} args
     * @return {*}
     */
    apply(operation, resource, args) {
        const request = Reflect.apply(operation, resource, args);
        this.history.push(request);

        return request;
    }
}
